<template>
  <div>
    <div style="white-space: pre-wrap">{{ value }}</div>
    <el-button
      type="primary"
      style="margin-top: 10px"
      size="mini"
      plain
      @click="openEditDialog"
      >编辑批注</el-button
    >
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      value: "",
    };
  },

  props: {
    keyword: String,
  },

  async created() {
    await this.loadMicrofilm();
  },
  components: {},

  methods: {
    /**
     * 查询可用附件集合
     */
    async loadMicrofilm() {
      this.value = await this.$bizutil.queryMicrofilm(this.keyword);
    },
    async openEditDialog() {
      this.$dialogutil.open("EditMicrofilmDialog", {
        closedCallback: async (param) => {
          if (param != null) {
            this.value = param.value;
          }
        },
        data: { key: this.keyword, value: this.value },
      });
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>
  
  